import React from "react";
import "./CardEvent.scss";
import { CalendarOutline } from "@/icons";

interface EventCardProps {
  type?: string;
  title: string;
  location?: string;
  date: string;
  link?: string;
  asLink?: "a" | React.ComponentType<any>;
}

export const CardEventSlim: React.FC<EventCardProps> = ({
  type = "Evento",
  title,
  location,
  date,
  link,
  asLink = "a",
}) => {
  const LinkComponent = asLink;

  return (
    <div className="event-card">
      <div className="event-card__header">
        <span className="event-card__icon">
          <CalendarOutline width={20} height={17} />
        </span>
        <span className="event-card__type">{type}</span>
      </div>
      <h1 className="event-card__title cursor-pointer hover-underline">
        {link ? <LinkComponent href={link}>{title}</LinkComponent> : title}
      </h1>
      <p className="event-card__info">
        {location && `${location}, `}
        <strong>{date}</strong>
      </p>
    </div>
  );
};
